/*export const globalLoader = {
  state: {
    loading: false
  },
  actions: {

  },
  mutations: {
    show(state) {
      state.loading = true;
    },
    hide(state) {
      state.loading = false;
    }
  },
  getters: {
    getGlobalLoaderState(state){
      return state.loading
    }
  }
};*/

const actions = {
  show(ctx) {
    ctx.commit('show');
  },
  hide(ctx) {
    ctx.commit('hide');
  }
}

const mutations = {
  show(state) {
    state.loading = true;
  },
  hide(state) {
    state.loading = false;
  }
}

const getters = {
  getGlobalLoaderState(state){
    return state.loading
  }
}

const state = {
  loading: true
}

export default {
  state,
  getters,
  mutations,
  actions,
}